import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubmenusActions } from './submenus.actions';
import { SubmenusSelectors } from './submenus.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {Submenu} from '@emm/core/models/submenu.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {getActionQueries} from '@emm/core/util/ngrx.util';


export interface SubmenusQueries extends AsyncActionQueries {
    all$: Observable<Submenu[]>;
    isEmpty$: Observable<boolean>;
    selected$: Observable<string>;
    selectedSearchSubmenu$: Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SubmenusStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>, private actions$: Actions) {
        super(store, SubmenusSelectors);
    }



    dispatch = {
        loadSubmenus: () => this.store.dispatch(SubmenusActions.load()),
        selectSubmenu: (tag: string) => this.store.dispatch(SubmenusActions.select({ tag })),
        selectSearchSubmenu: (tag: string) => this.store.dispatch(SubmenusActions.selectSearchSubmenu({ tag })),
        deselectSubmenu: (tag: string) => this.store.dispatch(SubmenusActions.deselect({ tag })),
        saveAssignments: (assignments: any[]) => this.store.dispatch(SubmenusActions.saveAssignments({ assignments })),
        addSubmenu: (submenu: any) => this.store.dispatch(SubmenusActions.add({ submenu })),
        filterSubmenus: (submenus) => this.store.dispatch(SubmenusActions.filterSubmenus({submenus})),
    };



    queries: SubmenusQueries = {
        all$: this.select(SubmenusSelectors.getValidAll).pipe(map((submenus) => submenus || [])),
        isEmpty$: this.select(SubmenusSelectors.getIsEmpty),
        selected$: this.select(SubmenusSelectors.getSelected),
        selectedSearchSubmenu$: this.select(SubmenusSelectors.getSelectedSearchSubmenu),
        ...this.asyncActionQueries,
        ...getActionQueries({
            actionCreators: SubmenusActions,
            actions$: this.actions$
        })
    };



}
